import JSZip from 'jszip';

export default class ClientTools {

    constructor(private proxyService: any){

    }

    private getBrowserName() {
        if (this.proxyService.isFirefox())
            return 'Mozilla Firefox';

        if (this.proxyService.isChrome())
            return 'Google Chrome';

        if (this.proxyService.isSafari())
            return 'Safari';

        if (this.proxyService.isMSIE9())
            return 'Internet Explorer 9';

        if (this.proxyService.isMSIE11())
            return 'Internet Explorer 11';

        if (this.proxyService.isOpera())
            return 'Opera';

        if (this.proxyService.isSamsungInternet())
            return 'Samsung Internet';

        return 'unknown';
    }

    private getDeviceType() {
        return this.proxyService.getDeviceType();
    }

    private getOperationSystem() {
        return this.proxyService.getOperationSystem();
    }

    private getDeviceTypeCompleteInformation() {
        return JSON.stringify(this.proxyService.getDeviceSystemData());
    }

    private getCookieEnabled() {
        return this.proxyService.isCookieEnabled();
    }

    private getBrowserAndOSVersion() {
        return this.proxyService.getUserAgent();
    }

    private getCGPVersion() {
        return this.proxyService.getCGPVersion();
    }

    private getOrbitVersion() {
        return this.proxyService.getOrbitVersion();
    }

    private getUserName() {
        return this.proxyService.getUserName();
    }

    private getCID() {
        return this.proxyService.getCID();
    }

    private isLoggedIn() {
        return this.proxyService.isAuthorized();
    }

    private getLauncherParams() {
        let cgp_client = localStorage.getItem('cgp_client');
        let parsed_cgp_client = JSON.parse(cgp_client);
        if (cgp_client)
            return JSON.stringify(parsed_cgp_client, null, 2);
        return 'unknown';
    }

    private getLanguage() {
        return this.proxyService.getLanguageIso3();
    }

    private getCountry() {
        return this.proxyService.getCountry();
    }

    private getBrand() {
        return this.proxyService.getBrand();
    }

    /* Pending new implementation in proxy service, since their location changed */
    // private getSegments() {
    //     return this.proxyService.getSegments();
    // }

    // private getConfigurationPath() {
    //     return this.proxyService.getConfigurationPath();
    // }

    private getOrbitConfigsVersion() {
        return this.proxyService.getOrbitConfigVersion();
    }

    private getEnvironment(): string {
        let serverUrl = this.proxyService.getEnviornmentOrigin() || '';

        if (serverUrl.indexOf('stage') !== -1)
            return 'STAGE - ' + serverUrl;
        if (serverUrl.indexOf('mirage') !== -1)
            return 'MIRAGE - ' + serverUrl;
        if (serverUrl.indexOf('cgp-nj') !== -1)
            return 'NJPE - ' + serverUrl;
        if (serverUrl === "https://cgp.safe-iplay.com")
            return 'PRODUCTION - ' + serverUrl;
        if (serverUrl === 'http://localhost:83')
            return 'DEV - ' + serverUrl;

        return 'unknown - ' + serverUrl;
    }

    private getLauncherURL() {
        let launcherURL = localStorage.getItem('888-launcher-url');
        if (launcherURL)
            return launcherURL;
        return 'unknown';
    }

    private getOrbitPath() {
        return this.proxyService.getOrbitPath();
    }

    private  getCGPClientPath() {
        return this.proxyService.getCGPClientPath();
    }

    private getScreenHeightAndWidth() {
        return this.proxyService.getScreenHeight() + ' x ' + this.proxyService.getScreenWidth();

    }

    private getIOSversion() {
        return this.proxyService.getIOSVersion();
    }

    private getIsPortrait() {
        return this.proxyService.isPortrait();
    }

    private getIsMobile() {
        return this.proxyService.isMobile();
    }

    private getIsTablet() {
        return this.proxyService.isTablet();
    }

    private getIsPC() {
        return this.proxyService.isPC();
    }

    private getCGPToken() {
        return JSON.stringify(this.proxyService.getToken());
    }

    private getRegulationIDFromToken() {
        return this.proxyService.getRegulationId();
    }

    private getCurrencyCodeFromToken() {
        return this.proxyService.getCurrencyCode();
    }

    private getProductPackageFromToken() {
        return this.proxyService.getProductPackage();
    }

    private getLoginTypeFromToken() {
        return this.proxyService.getLoginType();
    }

    private getIsMobileByOS() {
        return this.proxyService.isMobileByOS();
    }

    private getIsPokerHybrid() {
        return this.proxyService.isPokerHybrid();
    }

    private getIsSportHybrid() {
        return this.proxyService.isSportHybrid();
    }

    private getWindowPerformanceResources() {
        let performanceResources = this.proxyService.performanceResources.getEntriesByType('resource');
        let filteredPerformanceResources = [];
        performanceResources.forEach(function (performanceResource) {
            filteredPerformanceResources.push({
                duration: performanceResource.duration,
                name: performanceResource.name,
                initiatorType: performanceResource.initiatorType
            })
        });
        return JSON.stringify(filteredPerformanceResources, null, 2);
    }

    private getErrorLogs() {
        return JSON.stringify(this.proxyService.errorLogs, null, 2);
    }

    private replaceCircularDependency() { // needed for serializing objects with circular dependencies
        const seenValues = new WeakSet();
        return (key, value) => {
            if (typeof value === "object" && value !== null) {
                if (seenValues.has(value)) {
                    return 'CIRCULAR DEPENDENCY';
                }
                seenValues.add(value);
            }
            return value;
        };
    }

    private getLastOpenedGame() {
        let lastOpenedGame = this.proxyService.getLastOpenedGame();

        if (!lastOpenedGame)
            return null;

        if (!lastOpenedGame.wasSuccessful) {
            return JSON.stringify(lastOpenedGame, this.replaceCircularDependency(), 2);
        }

        let html5Url = '';
        let chillUrl = '';

        if (lastOpenedGame.data.grsData && lastOpenedGame.data.grsData.html5Url) {
            html5Url = lastOpenedGame.data.grsData.html5Url;
        }

        if (lastOpenedGame.data.grsData && lastOpenedGame.data.grsData.chillUrl) {
            chillUrl = lastOpenedGame.data.grsData.chillUrl;
        }

        let result = {
            wasSuccessful: lastOpenedGame.wasSuccessful,
            isReal: lastOpenedGame.isReal,
            html5Url: html5Url,
            chillUrl: chillUrl,
            initialGameOptions: lastOpenedGame.initialGameOptions,
            responseData: lastOpenedGame.data
        };

        return JSON.stringify(result, this.replaceCircularDependency(), 2);

    }

    public getContextDescription(bugFormatting = false, downloadLink = "") {

        try {

            let desc = '';

            if (bugFormatting)
                desc += '[System.History]=';

            let boldFormattingIn = '';
            let boldFormattingOut = '';
            let brFormatting = '\n';

            if (bugFormatting) {
                boldFormattingIn = '<b>';
                boldFormattingOut = '</b>';
                brFormatting = '<br>';
            }

            if (bugFormatting) {
                desc += `<a href%3D"${downloadLink}">AF Link</a>${brFormatting}`;
            }

            if (!bugFormatting) {
                desc += `${boldFormattingIn}LauncherURL:${boldFormattingOut} ` + this.getLauncherURL() + `${brFormatting}`;
            }

            desc += `${boldFormattingIn}Environment:${boldFormattingOut} ` + this.getEnvironment() + `${brFormatting}${brFormatting}`;

            desc += `${boldFormattingIn}Brand:${boldFormattingOut} ` + this.getBrand() + ', ';
            desc += `${boldFormattingIn}Language:${boldFormattingOut} ` + this.getLanguage() + ', ';
            desc += `${boldFormattingIn}Country:${boldFormattingOut} ` + this.getCountry() + `${brFormatting}${brFormatting}`;

            desc += `${boldFormattingIn}Paths: ${boldFormattingOut}${brFormatting}`;
            desc += `${boldFormattingIn}Orbit:${boldFormattingOut} ` + this.getOrbitPath() + `${brFormatting}`;
            desc += `${boldFormattingIn}CGP client:${boldFormattingOut} ` + this.getCGPClientPath() + `${brFormatting}`;
            // desc += `${boldFormattingIn}Config:${boldFormattingOut} ` + this.getConfigurationPath() + `${brFormatting}${brFormatting}`;

            desc += `${boldFormattingIn}Versions:${boldFormattingOut}${brFormatting}`;
            desc += `${boldFormattingIn}CGP:${boldFormattingOut} ` + this.getCGPVersion() + `${brFormatting}`;
            desc += `${boldFormattingIn}Orbit:${boldFormattingOut} ` + this.getOrbitVersion() + `${brFormatting}`;
            desc += `${boldFormattingIn}Orbit config:${boldFormattingOut} ` + this.getOrbitConfigsVersion() + `${brFormatting}${brFormatting}`;

            desc += `${boldFormattingIn}Logged in?${boldFormattingOut} ` + this.isLoggedIn() + `${brFormatting}`;
            if (this.isLoggedIn() === 'yes') {
                desc += `${boldFormattingIn}From token - ${boldFormattingOut} `;
                desc += `${boldFormattingIn}Login Type:${boldFormattingOut} ` + this.getLoginTypeFromToken() + ', ';
                desc += `${boldFormattingIn}Reg ID:${boldFormattingOut} ` + this.getRegulationIDFromToken() + ', ';
                desc += `${boldFormattingIn}Product package:${boldFormattingOut} ` + this.getProductPackageFromToken() + `${brFormatting}`;
            }

            if (!bugFormatting) {
                desc += `${boldFormattingIn}Currency code(from token):${boldFormattingOut} ` + this.getCurrencyCodeFromToken() + `${brFormatting}`;
            }

            desc += `${boldFormattingIn}Last login:${boldFormattingOut} `;
            desc += `${boldFormattingIn}Username:${boldFormattingOut} ` + this.getUserName() + ', ';
            desc += `${boldFormattingIn}CID:${boldFormattingOut} ` + this.getCID() + `${brFormatting}${brFormatting}`;

            if (!bugFormatting) {
                desc += `${boldFormattingIn}CGP.getToken(): ${boldFormattingOut}` + this.getCGPToken() + `${brFormatting}${brFormatting}`;
            }

            desc += `${boldFormattingIn}Browser Name${boldFormattingOut}: ` + this.getBrowserName() + `${brFormatting}`;
            desc += `${boldFormattingIn}UserAgent:${boldFormattingOut} ` + this.getBrowserAndOSVersion() + `${brFormatting}`;
            desc += `${boldFormattingIn}Screen Height x Width: ${boldFormattingOut}` + this.getScreenHeightAndWidth() + ', ';
            desc += `${boldFormattingIn}Portrait: ${boldFormattingOut}` + this.getIsPortrait() + `${brFormatting}`;
            desc += `${boldFormattingIn}OS${boldFormattingOut}: ` + this.getOperationSystem() + `, `;
            desc += `${boldFormattingIn}DeviceType${boldFormattingOut}: ` + this.getDeviceType();

            if (!bugFormatting) {
                desc += `${boldFormattingIn}Cookies on: ${boldFormattingOut}` + this.getCookieEnabled() + `${brFormatting}`;
                desc += `${boldFormattingIn}Mobile by OS${boldFormattingOut}: ` + this.getIsMobileByOS() + `${brFormatting}`;
                desc += `${boldFormattingIn}Device Type${boldFormattingOut}: ` + this.getDeviceTypeCompleteInformation() + `${brFormatting}`;

                desc += `${boldFormattingIn}PC: ${boldFormattingOut}` + this.getIsPC() + `${brFormatting}`;
                desc += `${boldFormattingIn}Mobile: ${boldFormattingOut}` + this.getIsMobile() + `${brFormatting}`;
                desc += `${boldFormattingIn}Tablet: ${boldFormattingOut}` + this.getIsTablet() + `${brFormatting}`;
                desc += `${boldFormattingIn}IOS Version: ${boldFormattingOut}` + this.getIOSversion() + `${brFormatting}`;
                desc += `${boldFormattingIn}Is Poker Hybrid: ${boldFormattingOut}` + this.getIsPokerHybrid() + `${brFormatting}`;
                desc += `${boldFormattingIn}Is Sport Hybrid: ${boldFormattingOut}` + this.getIsSportHybrid() + `${brFormatting}`;
            }

            if (bugFormatting) {
                desc += '&';
            }

            return desc;
        } catch (e) {
            console.error('ERROR IN CLIENT TOOLS SCRIPT:' + e.stack);
        }

    }

    private uploadArchiveToArtifactory(blob, isMobile) {

        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let threeDigitID = Math.floor(Math.random() * 1000);
        let milliseconds = Date.now();
        let bugID = threeDigitID.toString() + milliseconds.toString();

        let url = `/artifacts/${year}/${month}/${bugID}.zip`;
        let request = new XMLHttpRequest();

        /* To test the archive on localhost, where we can not make requests to Artifactory(need same origin) */
        // var a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style.display = "none";
        // var aLink = window.URL.createObjectURL(blob);
        // a.href = aLink;
        // a.download = "testArchive";
        // a.click();
        // window.URL.revokeObjectURL(aLink);
        // document.body.removeChild(a);

        request.onreadystatechange = () => {

            if (request.readyState === 4) {
                let downloadLink;

                if (request.status === 201) {
                    downloadLink = JSON.parse(request.response).downloadUri;
                } else {
                    downloadLink = `unsuccessful(code: ${request.status}) request to artifactory!`;
                }
                this._createNewBug(downloadLink, isMobile);
            }
        };

        request.addEventListener('error', (err) => console.log(err));

        request.open("PUT", url);
        request.send(blob);

    }


    private generateArchive(isMobile) {
        let zip = new JSZip();
        zip.file("performanceResources.json", this.getWindowPerformanceResources());
        zip.file("cgp_client(launcher JSON).json", this.getLauncherParams());
        // zip.file('segments.json', this.getSegments());
        zip.file("errorLogs.json", this.getErrorLogs());
        zip.file("lastOpenedGame.json", this.getLastOpenedGame());
        zip.file("completeContextDescription(bug discussion).txt", this.getContextDescription(false, 'unknown'));
        zip.generateAsync({type: 'blob'}).then(
            (zipBlob) => {
                this.uploadArchiveToArtifactory(zipBlob, isMobile);
            }
        );
    }

    public openNewBug() {

        try {
            if (this.proxyService.isMobile()) {
                this.generateArchive(true);
            } else {
                this.generateArchive(false);
            }
        } catch (e) {
            console.error('ERROR IN CLIENT TOOLS SCRIPT:' + e.stack);
        }
    }
    /*NOT ACTIVE RIGHT NOW, OPEN NEW BUG UPON PRESSING CTRL+ALT+B */
    public openNewBugKeydown(e) {

        try {
            if (e.key) {
                let pressedKey = e.key.toLowerCase();
                if (pressedKey === 'b' && e.getModifierState('Alt') && e.getModifierState('Control')) {
                    this.generateArchive(false);
                }
            }

        } catch (e) {
            console.error('ERROR IN CLIENT TOOLS SCRIPT:' + e.stack);
        }
    }

    private _createNewBug(downloadLink, isMobile) {
        let url = 'http://tfs2012:8080/tfs/DefaultCollection_2010/GamingNDL/Juno/_workItems/create/Bug?';
       // url += encodeURIComponent(this.getContextDescription(true, downloadLink));
        url+= this.getContextDescription(true, downloadLink);
        if (isMobile) {
                window.open(`mailto:?subject=New Mobile Bug&body=${url}`);
        } else {
            window.open(url);
        }
    }

}
